(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["react-control-panel"] = factory(require("react"));
	else
		root["react-control-panel"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__899__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 276:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(537);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel {
  font-family: 'Hack', monospace;
  font-size: 11px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  text-align: left;
  box-sizing: border-box;
}

.control-panel input {
  font-family: 'Hack';
  font-size: 11px;
}

.control-panel a {
  color: inherit;
  text-decoration: none;
}

.container {
  position: relative;
  min-height: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/base.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".control-panel {\n  font-family: 'Hack', monospace;\n  font-size: 11px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  cursor: default;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.control-panel input {\n  font-family: 'Hack';\n  font-size: 11px;\n}\n\n.control-panel a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.container {\n  position: relative;\n  min-height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 162:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(537);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Scp {
  width: 125px;
  height: 100px;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: relative;
  z-index: 1000;
  cursor: pointer;
}
.Scp-saturation {
  position: relative;
  width: calc(100% - 25px);
  height: 100%;
  background: linear-gradient(to right, #fff 0%, #f00 100%);
  float: left;
  margin-right: 5px;
}
.Scp-brightness {
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #000 0%, rgba(255,255,255,0) 100%);
}
.Scp-sbSelector {
  border: 1px solid;
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 10px;
  top: -7px;
  left: -7px;
  box-sizing: border-box;
  z-index: 10;
}
.Scp-hue {
  width: 20px;
  height: 100%;
  position: relative;
  float: left;
  background: linear-gradient(to bottom, #f00 0%, #f0f 17%, #00f 34%, #0ff 50%, #0f0 67%, #ff0 84%, #f00 100%);
}
.Scp-hSelector {
  position: absolute;
  background: #fff;
  border-bottom: 1px solid #000;
  right: -3px;
  width: 10px;
  height: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/color.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,yDAAyD;EACzD,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sEAAsE;AACxE;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,4GAA4G;AAC9G;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,WAAW;EACX,WAAW;AACb","sourcesContent":[".Scp {\n  width: 125px;\n  height: 100px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: relative;\n  z-index: 1000;\n  cursor: pointer;\n}\n.Scp-saturation {\n  position: relative;\n  width: calc(100% - 25px);\n  height: 100%;\n  background: linear-gradient(to right, #fff 0%, #f00 100%);\n  float: left;\n  margin-right: 5px;\n}\n.Scp-brightness {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to top, #000 0%, rgba(255,255,255,0) 100%);\n}\n.Scp-sbSelector {\n  border: 1px solid;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 10px;\n  top: -7px;\n  left: -7px;\n  box-sizing: border-box;\n  z-index: 10;\n}\n.Scp-hue {\n  width: 20px;\n  height: 100%;\n  position: relative;\n  float: left;\n  background: linear-gradient(to bottom, #f00 0%, #f0f 17%, #00f 34%, #0ff 50%, #0f0 67%, #ff0 84%, #f00 100%);\n}\n.Scp-hSelector {\n  position: absolute;\n  background: #fff;\n  border-bottom: 1px solid #000;\n  right: -3px;\n  width: 10px;\n  height: 2px;\n}"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 387:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(537);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel-interval {
  -webkit-appearance: none;
  position: absolute;
  height: 20px;
  margin: 0px 0;
  width: 33%;
  left: 52.5%;
  cursor: ew-resize;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.control-panel-interval .control-panel-interval-handle {
  position: absolute;
  height: 20px;
  min-width: 1px;
}

.control-panel-interval-dragging * {
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;

  cursor: ew-resize !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/interval.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,iBAAiB;;EAEjB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;;EAE5B,4BAA4B;AAC9B","sourcesContent":[".control-panel-interval {\n  -webkit-appearance: none;\n  position: absolute;\n  height: 20px;\n  margin: 0px 0;\n  width: 33%;\n  left: 52.5%;\n  cursor: ew-resize;\n\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.control-panel-interval .control-panel-interval-handle {\n  position: absolute;\n  height: 20px;\n  min-width: 1px;\n}\n\n.control-panel-interval-dragging * {\n  -webkit-touch-callout: none !important;\n  -webkit-user-select: none !important;\n  -khtml-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n\n  cursor: ew-resize !important;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 645:
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ 537:
/***/ ((module) => {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ 419:
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 410:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hasSymbols = __webpack_require__(419);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 186:
/***/ ((module) => {

var containers = []; // will store container HTMLElement references
var styleElements = []; // will store {prepend: HTMLElement, append: HTMLElement}

var usage = 'insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).';

function insertCss(css, options) {
    options = options || {};

    if (css === undefined) {
        throw new Error(usage);
    }

    var position = options.prepend === true ? 'prepend' : 'append';
    var container = options.container !== undefined ? options.container : document.querySelector('head');
    var containerId = containers.indexOf(container);

    // first time we see this container, create the necessary entries
    if (containerId === -1) {
        containerId = containers.push(container) - 1;
        styleElements[containerId] = {};
    }

    // try to get the correponding container + position styleElement, create it otherwise
    var styleElement;

    if (styleElements[containerId] !== undefined && styleElements[containerId][position] !== undefined) {
        styleElement = styleElements[containerId][position];
    } else {
        styleElement = styleElements[containerId][position] = createStyleElement();

        if (position === 'prepend') {
            container.insertBefore(styleElement, container.childNodes[0]);
        } else {
            container.appendChild(styleElement);
        }
    }

    // strip potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xFEFF) { css = css.substr(1, css.length); }

    // actually add the stylesheet
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText += css
    } else {
        styleElement.textContent += css;
    }

    return styleElement;
};

function createStyleElement() {
    var styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    return styleElement;
}

module.exports = insertCss;
module.exports.insertCss = insertCss;


/***/ }),

/***/ 114:
/***/ (function(module, exports) {

(function(root) {
  'use strict';

  function isNumeric(v, opts) {
    if (!(opts instanceof Object)) {
      opts = {
        trim: true
      }
    }
    if (typeof v === 'number' && !isNaN(v)) return true;
    v = (v||'').toString()
    if ('trim' in opts && !opts.trim) {
      return !/\s/.test(v)
    }
    v = v.trim()
    if (!v) return false;
    return !isNaN(v);
  }

  if (true) {
    if ( true && module.exports) {
      exports = module.exports = isNumeric;
    }
    exports.isNumeric = isNumeric;
  } else {}

})(this);


/***/ }),

/***/ 981:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(410)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),

/***/ 703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(703)();
}


/***/ }),

/***/ 414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 899:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__899__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Button: () => (/* reexport */ components_button),
  Checkbox: () => (/* reexport */ components_checkbox),
  Color: () => (/* reexport */ color),
  Container: () => (/* reexport */ Container),
  Custom: () => (/* reexport */ custom),
  InnerRange: () => (/* reexport */ InnerRange),
  Interval: () => (/* reexport */ components_interval),
  Label: () => (/* reexport */ Label),
  Multibox: () => (/* reexport */ multibox),
  Range: () => (/* reexport */ components_range),
  Select: () => (/* reexport */ components_select),
  Text: () => (/* reexport */ components_text),
  Value: () => (/* reexport */ value),
  "default": () => (/* binding */ src),
  themes: () => (/* reexport */ themes),
  withSettingState: () => (/* reexport */ withSettingState),
  withTheme: () => (/* reexport */ withTheme)
});

// EXTERNAL MODULE: external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
var external_root_React_commonjs_react_commonjs2_react_amd_react_ = __webpack_require__(899);
var external_root_React_commonjs_react_commonjs2_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs_react_commonjs2_react_amd_react_);
// EXTERNAL MODULE: ./node_modules/is-string/index.js
var is_string = __webpack_require__(981);
var is_string_default = /*#__PURE__*/__webpack_require__.n(is_string);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/themes.js
/* harmony default export */ const themes = ({
  light: {
    background1: 'rgb(227,227,227)',
    background2: 'rgb(204,204,204)',
    background2hover: 'rgb(208,208,208)',
    foreground1: 'rgb(105,105,105)',
    text1: 'rgb(36,36,36)',
    text2: 'rgb(87,87,87)'
  },
  dark: {
    background1: 'rgb(35,35,35)',
    background2: 'rgb(54,54,54)',
    background2hover: 'rgb(58,58,58)',
    foreground1: 'rgb(112,112,112)',
    text1: 'rgb(235,235,235)',
    text2: 'rgb(161,161,161)'
  }
});
;// CONCATENATED MODULE: ./node_modules/shallow-equal/dist/index.esm.js
function shallowEqualObjects(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (!objA || !objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  var len = aKeys.length;

  if (bKeys.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }
  }

  return true;
}

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}



// EXTERNAL MODULE: ./node_modules/is-numeric/is-numeric.js
var is_numeric = __webpack_require__(114);
var is_numeric_default = /*#__PURE__*/__webpack_require__.n(is_numeric);
;// CONCATENATED MODULE: ./src/error.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


var InvalidParamsError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidParamsError, _Error);
  var _super = _createSuper(InvalidParamsError);
  function InvalidParamsError() {
    _classCallCheck(this, InvalidParamsError);
    return _super.apply(this, arguments);
  }
  return _createClass(InvalidParamsError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ErrMsg = function ErrMsg(_ref) {
  var msg = _ref.msg;
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    style: {
      color: 'red'
    }
  }, msg);
};
var ErrorHandlerWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorHandlerWrapper, _React$Component);
  var _super2 = _createSuper(ErrorHandlerWrapper);
  function ErrorHandlerWrapper() {
    var _this;
    _classCallCheck(this, ErrorHandlerWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null
    });
    return _this;
  }
  _createClass(ErrorHandlerWrapper, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, info) {
      this.setState({
        errMsg: err.message
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.errMsg) {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(ErrMsg, {
          msg: this.state.errMsg
        });
      } else {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(this.props.Comp, this.props);
      }
    }
  }]);
  return ErrorHandlerWrapper;
}((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Component);
var withErrorHandler = function withErrorHandler(Comp) {
  return function (_ref2) {
    var props = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(ErrorHandlerWrapper, _extends({
      Comp: Comp
    }, props));
  };
};
var createValidator = function createValidator(checkIfInvalid, createErrMsg) {
  return function () {
    if (!checkIfInvalid.apply(void 0, arguments)) {
      return;
    }
    throw new InvalidParamsError(createErrMsg.apply(void 0, arguments));
  };
};
var validateStepParams = createValidator(function (step, steps) {
  return !!step && !!steps;
}, function (step, steps) {
  return "Cannot specify both step and steps. Got step = ".concat(step, ", steps = ").concat(steps);
});
var validateLogStep = createValidator((is_numeric_default()), function (step) {
  return "Log may only use steps (integer number of steps), not a step value. Got step = ".concat(step);
});
var validateLogMinMax = createValidator(function (min, max) {
  return min * max <= 0;
}, function (min, max) {
  return "Log range min/max must have the same sign and not equal zero. Got min = ".concat(min, ", max = ").concat(max);
});
var throwLogRangeError = createValidator(function (scaledVal) {
  return true;
}, function (scaledVal) {
  return "Log range initial value must have the same sign as min/max and must not equal zero. Got initial value = ".concat(scaledVal);
});
;// CONCATENATED MODULE: ./src/util.js
function util_typeof(o) { "@babel/helpers - typeof"; return util_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, util_typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { util_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function util_defineProperty(obj, key, value) { key = util_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function util_toPropertyKey(t) { var i = util_toPrimitive(t, "string"); return "symbol" == util_typeof(i) ? i : String(i); }
function util_toPrimitive(t, r) { if ("object" != util_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != util_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var getLogScalerFunctions = function getLogScalerFunctions(logmin, logmax, logsign) {
  return {
    scaleValue: function scaleValue(x) {
      return logsign * Math.exp(Math.log(logmin) + (Math.log(logmax) - Math.log(logmin)) * x / 100);
    },
    scaleValueInverse: function scaleValueInverse(y) {
      return (Math.log(y * logsign) - Math.log(logmin)) * 100 / (Math.log(logmax) - Math.log(logmin));
    }
  };
};
var numericOrDefault = function numericOrDefault(val, defaultVal) {
  return is_numeric_default()(val) ? val : defaultVal;
};
// lazy version
var numericOrDefaultElse = function numericOrDefaultElse(val, getDefaultVal) {
  return is_numeric_default()(val) ? val : getDefaultVal();
};
var createNormalDisplayOptsGetter = function createNormalDisplayOptsGetter(transformVal) {
  return function (_ref) {
    var min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      value = _ref.value;
    var newMin = numericOrDefault(min, 0);
    var newMax = numericOrDefault(max, 100);
    var transformedVal = transformVal(newMin, newMax, value);
    return {
      min: newMin,
      max: newMax,
      step: numericOrDefault(step, (max - min) / 100),
      sliderVal: transformedVal,
      logVal: transformedVal,
      scaleValue: function scaleValue(x) {
        return x;
      }
    };
  };
};
var withScalerFunctions = function withScalerFunctions(logOptsGetter) {
  return function (args) {
    var min = args.min,
      max = args.max,
      step = args.step;
    validateLogMinMax(min, max);
    validateLogStep(step);
    var logsign = min > 0 ? 1 : -1;
    var logmin = Math.abs(min);
    var logmax = Math.abs(max);
    return logOptsGetter(_objectSpread(_objectSpread({}, args), getLogScalerFunctions(logmin, logmax, logsign)));
  };
};

/**
 * Since apparently 15% of users worldwide don't have a browser that supports `Proxy`, we create
 * a partial polyfill that fits our needs.
 */
var createPolyProxy = function createPolyProxy(target, handler, setState) {
  if (typeof Proxy === 'function') {
    return new Proxy(target, handler);
  }
  var proxy = {};
  var props = Object.entries(target).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      val = _ref3[1];
    if (key in acc) {
      return acc;
    }
    return _objectSpread(_objectSpread({}, acc), {}, util_defineProperty({}, key, {
      enumerable: !!Object.getOwnPropertyDescriptor(target, key).enumerable,
      get: function get() {
        return target[key];
      },
      set: function set(newVal) {
        return setState(util_defineProperty({}, key, newVal));
      }
    }));
  }, {});
  Object.defineProperties(proxy, props);
  return proxy;
};
var compose = function compose() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function (arg) {
    return functions.reduceRight(function (acc, fun) {
      return fun(acc);
    }, arg);
  };
};
var clamp = function clamp(x, min, max) {
  return Math.min(Math.max(x, min), max);
};

/**
 * Taken from
 */
function useMemoCompare(next, compare) {
  // Ref for storing previous value
  var previousRef = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useRef();
  var previous = previousRef.current;
  // Pass previous and next value to compare function
  // to determine whether to consider them equal.
  var isEqual = compare(previous, next);
  // If not equal update previousRef to next value.
  // We only update if not equal so that this hook continues to return
  // the same old value if compare keeps returning true.
  external_root_React_commonjs_react_commonjs2_react_amd_react_default().useEffect(function () {
    if (!isEqual) {
      previousRef.current = next;
    }
  });
  // Finally, if equal then return the previous value
  return isEqual ? previous : next;
}
;// CONCATENATED MODULE: ./src/components/context.js
function context_typeof(o) { "@babel/helpers - typeof"; return context_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, context_typeof(o); }
var _excluded = ["state", "label", "theme", "mapPropsToStyles", "indicateChange", "LabelComponent", "Comp"];
function context_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function context_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? context_ownKeys(Object(t), !0).forEach(function (r) { context_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : context_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function context_defineProperty(obj, key, value) { key = context_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function context_toPropertyKey(t) { var i = context_toPrimitive(t, "string"); return "symbol" == context_typeof(i) ? i : String(i); }
function context_toPrimitive(t, r) { if ("object" != context_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != context_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function context_extends() { context_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return context_extends.apply(this, arguments); }
function context_objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }



var ControlPanelContext = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createContext({});
/* harmony default export */ const context = (ControlPanelContext);
var withTheme = function withTheme(Comp) {
  return function (_ref) {
    var props = Object.assign({}, (context_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(ControlPanelContext.Consumer, null, function (_ref2) {
      var theme = _ref2.theme;
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(Comp, context_extends({
        theme: theme
      }, props));
    });
  };
};
var getLabelStyles = function getLabelStyles(theme) {
  return {
    body: {
      left: 0,
      width: '36%',
      display: 'inline-block',
      height: 20,
      paddingRight: '2%',
      verticalAlign: 'top'
    },
    text: {
      color: theme.text1,
      display: 'inline-block',
      verticalAlign: 'sub'
    }
  };
};
var Label = withTheme(function (_ref3) {
  var label = _ref3.label,
    theme = _ref3.theme;
  var styles = getLabelStyles(theme);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
    style: styles.body,
    className: "draggable"
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    title: label,
    className: "draggable",
    style: styles.text
  }, label));
});
var Container = function Container(_ref4) {
  var label = _ref4.label,
    LabelComponent = _ref4.LabelComponent,
    children = _ref4.children;
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
    className: "container draggable"
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(Label, {
    label: LabelComponent ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(LabelComponent, {
      label: label
    }) : label || ''
  }), children);
};
var ContainerMemo = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().memo(Container);
var WithSettingStateInner = function WithSettingStateInner(_ref5) {
  var state = _ref5.state,
    label = _ref5.label,
    theme = _ref5.theme,
    mapPropsToStyles = _ref5.mapPropsToStyles,
    indicateChange = _ref5.indicateChange,
    LabelComponent = _ref5.LabelComponent,
    Comp = _ref5.Comp,
    props = _objectWithoutProperties(_ref5, _excluded);
  var onChange = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useCallback(function (newVal) {
    return indicateChange(label, newVal);
  }, [label, indicateChange]);
  var compProps = context_objectSpread({
    value: state[label],
    onChange: onChange,
    theme: theme
  }, props);
  var memoizedCompProps = useMemoCompare(compProps, shallowEqualObjects);
  var styles = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useMemo(function () {
    return mapPropsToStyles ? mapPropsToStyles(memoizedCompProps) : undefined;
  }, [mapPropsToStyles, memoizedCompProps]);
  if (mapPropsToStyles) {
    compProps.styles = styles;
  }
  var children = /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(Comp, compProps);
  var renderContainer = props.renderContainer === false ? false : true;
  if (renderContainer && typeof label === 'string') {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(ContainerMemo, {
      LabelComponent: LabelComponent,
      label: label
    }, children);
  }
  return children;
};
var withSettingState = function withSettingState(mapPropsToStyles) {
  return function (Comp) {
    var WithSettingState = function WithSettingState(props) {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(ControlPanelContext.Consumer, null, function (ctxProps) {
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(WithSettingStateInner, context_extends({}, ctxProps, {
          Comp: Comp
        }, props, {
          mapPropsToStyles: mapPropsToStyles
        }));
      });
    };
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().memo(WithSettingState);
  };
};
;// CONCATENATED MODULE: ./src/components/title.js


/* harmony default export */ const components_title = (withTheme(function (_ref) {
  var title = _ref.title,
    theme = _ref.theme;
  var style = {
    width: '100%',
    textAlign: 'center',
    color: theme.text2,
    textTransform: 'uppercase',
    height: 20,
    marginBottom: 4
  };
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
    style: style,
    className: "draggable"
  }, title);
}));
;// CONCATENATED MODULE: ./src/components/button.js
function button_typeof(o) { "@babel/helpers - typeof"; return button_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, button_typeof(o); }
function button_slicedToArray(arr, i) { return button_arrayWithHoles(arr) || button_iterableToArrayLimit(arr, i) || button_unsupportedIterableToArray(arr, i) || button_nonIterableRest(); }
function button_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function button_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return button_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return button_arrayLikeToArray(o, minLen); }
function button_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function button_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function button_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function button_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function button_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? button_ownKeys(Object(t), !0).forEach(function (r) { button_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : button_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function button_defineProperty(obj, key, value) { key = button_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function button_toPropertyKey(t) { var i = button_toPrimitive(t, "string"); return "symbol" == button_typeof(i) ? i : String(i); }
function button_toPrimitive(t, r) { if ("object" != button_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != button_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var getStyle = function getStyle(theme, _ref) {
  var focused = _ref.focused,
    active = _ref.active,
    hover = _ref.hover,
    disabled = _ref.disabled;
  var hoverStyle = {
    color: theme.text2,
    backgroundColor: theme.background2hover
  };
  var activeStyle = {
    color: theme.background2,
    backgroundColor: theme.text2
  };
  var disabledStyle = {
    filter: 'contrast(0.5)',
    cursor: 'default'
  };
  return button_objectSpread(button_objectSpread(button_objectSpread({
    position: 'absolute',
    textAlign: 'center',
    height: 20,
    width: '62%',
    border: 'none',
    cursor: 'pointer',
    right: 0,
    fontFamily: 'inherit',
    color: theme.text2,
    backgroundColor: theme.background2,
    outline: focused ? 'none' : undefined
  }, hover ? hoverStyle : {}), active ? activeStyle : {}), disabled ? disabledStyle : {});
};
var UnwrappedButton = function UnwrappedButton(_ref2) {
  var theme = _ref2.theme,
    action = _ref2.action,
    label = _ref2.label,
    disabled = _ref2.disabled;
  var _React$useState = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useState(false),
    _React$useState2 = button_slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var _React$useState3 = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useState(false),
    _React$useState4 = button_slicedToArray(_React$useState3, 2),
    hover = _React$useState4[0],
    setHover = _React$useState4[1];
  var _React$useState5 = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useState(false),
    _React$useState6 = button_slicedToArray(_React$useState5, 2),
    active = _React$useState6[0],
    setActive = _React$useState6[1];
  var style = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useMemo(function () {
    return getStyle(theme, {
      focused: focused,
      active: active,
      hover: hover,
      disabled: disabled
    });
  }, [theme, focused, active, hover, disabled]);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(Container, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("button", {
    style: style,
    onClick: action,
    disabled: disabled,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onMouseDown: function onMouseDown() {
      setActive(true);
      if (onmousedown) {
        onmousedown();
      }
    },
    onMouseUp: function onMouseUp() {
      setActive(false);
      if (onmouseup) {
        onmouseup();
      }
    }
  }, label));
};
var Button = withTheme(UnwrappedButton);
Button.propTypes = {
  action: (prop_types_default()).func,
  disabled: (prop_types_default()).bool,
  onmousedown: (prop_types_default()).func,
  onmouseup: (prop_types_default()).func,
  label: (prop_types_default()).string.isRequired
};
/* harmony default export */ const components_button = (Button);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ const esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ const esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ const esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ./src/components/checkbox.js
function checkbox_typeof(o) { "@babel/helpers - typeof"; return checkbox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, checkbox_typeof(o); }
function checkbox_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function checkbox_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? checkbox_ownKeys(Object(t), !0).forEach(function (r) { checkbox_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : checkbox_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkbox_defineProperty(obj, key, value) { key = checkbox_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function checkbox_toPropertyKey(t) { var i = checkbox_toPrimitive(t, "string"); return "symbol" == checkbox_typeof(i) ? i : String(i); }
function checkbox_toPrimitive(t, r) { if ("object" != checkbox_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != checkbox_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var Checkbox = function Checkbox(_ref) {
  var theme = _ref.theme,
    checked = _ref.value,
    _onChange = _ref.onChange,
    styles = _ref.styles;
  var id = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useRef)(esm_browser_v4());
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("input", {
    id: id.current,
    type: "checkbox",
    checked: checked,
    style: styles.checkbox,
    onChange: function onChange() {
      return _onChange(!checked);
    }
  }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("label", {
    htmlFor: id.current,
    style: styles.label
  }));
};
var mapPropsToStyles = function mapPropsToStyles(_ref2) {
  var theme = _ref2.theme,
    checked = _ref2.value;
  var labelCheckedStyle = {
    width: 10,
    height: 10,
    backgroundColor: theme.foreground1,
    border: "solid 4px ".concat(theme.background2),
    cursor: 'pointer'
  };
  return {
    checkbox: {
      display: 'none',
      cursor: 'pointer'
    },
    label: checkbox_objectSpread({
      display: 'inline-block',
      width: 18,
      height: 18,
      padding: 0,
      verticalAlign: 'middle',
      marginRight: 8,
      marginTop: 2,
      backgroundColor: theme.background2,
      borderRadius: 0,
      cursor: 'pointer'
    }, checked ? labelCheckedStyle : {})
  };
};
/* harmony default export */ const components_checkbox = (withSettingState(mapPropsToStyles)(Checkbox));
;// CONCATENATED MODULE: ./src/components/multibox.js
function multibox_typeof(o) { "@babel/helpers - typeof"; return multibox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, multibox_typeof(o); }
function multibox_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function multibox_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? multibox_ownKeys(Object(t), !0).forEach(function (r) { multibox_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : multibox_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function multibox_defineProperty(obj, key, value) { key = multibox_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function multibox_toPropertyKey(t) { var i = multibox_toPrimitive(t, "string"); return "symbol" == multibox_typeof(i) ? i : String(i); }
function multibox_toPrimitive(t, r) { if ("object" != multibox_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != multibox_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var UnwrappedMultibox = function UnwrappedMultibox(_ref) {
  var theme = _ref.theme,
    colors = _ref.colors,
    names = _ref.names,
    count = _ref.count,
    value = _ref.value,
    onChange = _ref.onChange,
    styles = _ref.styles;
  var HydratedCheckbox = function HydratedCheckbox(checked, i) {
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, {
      key: i
    }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
      style: styles.getContentStyle(i, checked),
      onClick: function onClick() {
        // dirty mutation below
        value[i] = !checked;
        onChange(value);
      }
    }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("input", {
      type: "checkbox",
      defaultChecked: checked,
      style: styles.checkbox
    }), names[i] ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
      style: styles.label
    }, names[i]) : null);
  };
  var checkboxValues = value || new Array(count).map(function (_v, i) {
    return value[i] || false;
  });
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
    style: styles.main
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    style: styles.innerWrapper
  }, checkboxValues.map(HydratedCheckbox)));
};
var multibox_mapPropsToStyles = function mapPropsToStyles(_ref2) {
  var theme = _ref2.theme,
    colors = _ref2.colors;
  return {
    main: {
      position: 'relative',
      width: '60%',
      display: 'inline-block',
      paddingBottom: 7
    },
    innerWrapper: {
      display: 'inline-block'
    },
    checkbox: {
      display: 'none',
      cursor: 'pointer'
    },
    label: {
      backgroundColor: theme.background2,
      paddingRight: 7,
      verticalAlign: 'middle',
      padding: 2,
      marginRight: 8,
      color: theme.text2
    },
    getContentStyle: function getContentStyle(i, checked) {
      var checkedStyle = {
        width: 10,
        height: 10,
        border: "solid 4px ".concat(theme.background2),
        cursor: 'pointer',
        backgroundColor: checked ? colors[i] : theme.foreground1
      };
      return multibox_objectSpread({
        display: 'inline-block',
        width: 18,
        height: 18,
        padding: 0,
        verticalAlign: 'middle',
        marginRight: 8,
        marginTop: 2,
        marginBottom: 1,
        backgroundColor: theme.background2,
        borderRadius: 0,
        cursor: 'pointer'
      }, checked ? checkedStyle : {});
    }
  };
};
var Multibox = withSettingState(multibox_mapPropsToStyles)(UnwrappedMultibox);
Multibox.propTypes = {
  colors: (prop_types_default()).array,
  names: prop_types_default().arrayOf((prop_types_default()).string),
  count: (prop_types_default()).number
};
Multibox.defaultProps = {
  colors: [],
  names: [],
  count: 2
};
/* harmony default export */ const multibox = (Multibox);
;// CONCATENATED MODULE: ./src/components/select.js
function select_typeof(o) { "@babel/helpers - typeof"; return select_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, select_typeof(o); }
function select_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function select_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? select_ownKeys(Object(t), !0).forEach(function (r) { select_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : select_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function select_defineProperty(obj, key, value) { key = select_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function select_toPropertyKey(t) { var i = select_toPrimitive(t, "string"); return "symbol" == select_typeof(i) ? i : String(i); }
function select_toPrimitive(t, r) { if ("object" != select_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != select_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function select_slicedToArray(arr, i) { return select_arrayWithHoles(arr) || select_iterableToArrayLimit(arr, i) || select_unsupportedIterableToArray(arr, i) || select_nonIterableRest(); }
function select_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function select_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return select_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return select_arrayLikeToArray(o, minLen); }
function select_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function select_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function select_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var getOptions = function getOptions(options) {
  var keyVals = Array.isArray(options) ? options.map(function (opt) {
    return [opt, opt];
  }) : Object.entries(options);
  return keyVals.map(function (_ref) {
    var _ref2 = select_slicedToArray(_ref, 2),
      val = _ref2[0],
      key = _ref2[1];
    return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("option", {
      key: key,
      value: key
    }, val);
  });
};
var Select = function Select(_ref3) {
  var options = _ref3.options,
    theme = _ref3.theme,
    value = _ref3.value,
    _onChange = _ref3.onChange,
    styles = _ref3.styles;
  var selectRef = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useRef(null);
  // Blur the select when the value changes to prevent keypresses from being
  // interpreted as changing the value.
  external_root_React_commonjs_react_commonjs2_react_amd_react_default().useEffect(function () {
    selectRef.current.blur();
  }, [value]);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    style: styles.traingleUp
  }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    style: styles.triangleDown
  }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("select", {
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    style: styles.select,
    ref: selectRef
  }, getOptions(options)));
};
var select_mapPropsToStyles = function mapPropsToStyles(_ref4) {
  var theme = _ref4.theme;
  var triangle = {
    borderRight: '3px solid transparent',
    borderLeft: '3px solid transparent',
    lineHeight: 20,
    position: 'absolute',
    right: '2.5%',
    zIndex: 1,
    cursor: 'auto'
  };
  return {
    select: {
      display: 'inlineBlock',
      position: 'absolute',
      width: '62%',
      paddingLeft: '1.5%',
      height: 20,
      border: 'none',
      borderRadius: 0,
      outline: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      OAppearance: 'none',
      fontFamily: 'inherit',
      backgroundColor: theme.background2,
      color: theme.text2
    },
    traingleUp: select_objectSpread(select_objectSpread({}, triangle), {}, {
      top: 11,
      borderTop: "5px solid ".concat(theme.text2),
      borderBottom: '0px transparent'
    }),
    triangleDown: select_objectSpread(select_objectSpread({}, triangle), {}, {
      top: 4,
      borderBottom: "5px solid ".concat(theme.text2),
      borderTop: '0px transparent'
    })
  };
};
/* harmony default export */ const components_select = (withSettingState(select_mapPropsToStyles)(Select));
;// CONCATENATED MODULE: ./src/components/text.js
function text_typeof(o) { "@babel/helpers - typeof"; return text_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, text_typeof(o); }
function text_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function text_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? text_ownKeys(Object(t), !0).forEach(function (r) { text_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : text_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function text_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, text_toPropertyKey(descriptor.key), descriptor); } }
function text_createClass(Constructor, protoProps, staticProps) { if (protoProps) text_defineProperties(Constructor.prototype, protoProps); if (staticProps) text_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function text_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function text_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) text_setPrototypeOf(subClass, superClass); }
function text_setPrototypeOf(o, p) { text_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return text_setPrototypeOf(o, p); }
function text_createSuper(Derived) { var hasNativeReflectConstruct = text_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = text_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = text_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return text_possibleConstructorReturn(this, result); }; }
function text_possibleConstructorReturn(self, call) { if (call && (text_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return text_assertThisInitialized(self); }
function text_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function text_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function text_getPrototypeOf(o) { text_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return text_getPrototypeOf(o); }
function text_defineProperty(obj, key, value) { key = text_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function text_toPropertyKey(t) { var i = text_toPrimitive(t, "string"); return "symbol" == text_typeof(i) ? i : String(i); }
function text_toPrimitive(t, r) { if ("object" != text_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != text_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var Text = /*#__PURE__*/function (_React$Component) {
  text_inherits(Text, _React$Component);
  var _super = text_createSuper(Text);
  function Text() {
    var _this;
    text_classCallCheck(this, Text);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    text_defineProperty(text_assertThisInitialized(_this), "state", {
      focused: false
    });
    text_defineProperty(text_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("input", {
        style: text_objectSpread(text_objectSpread({}, _this.props.styles.body), {}, {
          outline: _this.state.focused ? 'none' : undefined
        }),
        onFocus: function onFocus() {
          return _this.setState({
            focused: true
          });
        },
        onBlur: function onBlur() {
          return _this.setState({
            focused: false
          });
        },
        type: "text",
        value: _this.props.value,
        onChange: function onChange(e) {
          return _this.props.onChange(e.target.value);
        }
      });
    });
    return _this;
  }
  return text_createClass(Text);
}((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Component);
var text_mapPropsToStyles = function mapPropsToStyles(_ref) {
  var theme = _ref.theme;
  return {
    body: {
      position: 'absolute',
      paddingLeft: 6,
      height: 20,
      width: '59.5%',
      border: 'none',
      background: theme.background2,
      color: theme.text2,
      fontFamily: 'inherit'
    }
  };
};
/* harmony default export */ const components_text = (withSettingState(text_mapPropsToStyles)(Text));
// EXTERNAL MODULE: ./node_modules/insert-css/index.js
var insert_css = __webpack_require__(186);
;// CONCATENATED MODULE: ./node_modules/simple-color-picker/dist/simple-color-picker.module.js
function e(t,e){for(var i=0;i<e.length;i++){var o=e[i];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function i(t,i,o){return i&&e(t.prototype,i),o&&e(t,o),t}function o(t){return"number"==typeof t&&!isNaN(t)}function s(t,e,i){return Math.min(Math.max(t,e),i)}function n(t){if(0===t.type.indexOf("touch")){var e=t.touches[0];return{x:e.clientX,y:e.clientY}}return{x:t.clientX,y:t.clientY}}function r(t){return 1==t.length?"0"+t:""+t}var h=function(){function t(t){this._rgba={r:0,g:0,b:0,a:1},this._hsva={h:0,s:0,v:0,a:1},this.fromHex(t)}var e=t.prototype;return e.fromHex=function(t){t||(t=0),o(t)?(this._hexNumber=t,this._hexString=function(t){return"#"+("00000"+(0|t).toString(16)).substr(-6).toUpperCase()}(this._hexNumber)):(this._hexString=t.toUpperCase(),this._hexNumber=u(this._hexString));var e=function(t){return{r:(t>>16&255)/255,g:(t>>8&255)/255,b:(255&t)/255}}(this._hexNumber),i=e.g,s=e.b;this._rgba.r=e.r,this._rgba.g=i,this._rgba.b=s;var n=function(t){var e,i=t.r,o=t.g,s=t.b,n=Math.max(i,o,s),r=Math.min(i,o,s),h=n-r,u=0===n?0:h/n,a=n;if(n==r)e=0;else{switch(n){case i:e=(o-s)/h+(o<s?6:0);break;case o:e=(s-i)/h+2;break;case s:e=(i-o)/h+4}e/=6}return{h:e,s:u,v:a}}(this._rgba),r=n.s,h=n.v;this._hsva.h=n.h,this._hsva.s=r,this._hsva.v=h,this._updateBrightness()},e.fromHsv=function(t){var e=t.s,i=t.v;this._hsva.h=t.h,this._hsva.s=e,this._hsva.v=i;var o=function(t){var e=t.h,i=t.s,o=t.v;e*=6;var s=Math.floor(e),n=e-s,r=o*(1-i),h=o*(1-n*i),u=o*(1-(1-n)*i),a=s%6;return{r:[o,h,r,r,u,o][a],g:[u,o,o,h,r,r][a],b:[r,r,u,o,o,h][a]}}(this._hsva),s=o.g,n=o.b;this._rgba.r=o.r,this._rgba.g=s,this._rgba.b=n,this._hexString=function(t){var e=t.g,i=t.b;return["#",r(Math.round(255*t.r).toString(16)),r(Math.round(255*e).toString(16)),r(Math.round(255*i).toString(16))].join("").toUpperCase()}(this._rgba),this._hexNumber=u(this._hexString),this._updateBrightness()},e._updateBrightness=function(){var t=this._rgba;this._brightness=(299*t.r+587*t.g+114*t.b)/1e3,this._isDark=this._brightness<.5,this._isLight=!this._isDark},i(t,[{key:"rgb",get:function(){return this._rgba}},{key:"hsv",get:function(){return this._hsva}},{key:"hex",get:function(){return this._hexNumber}},{key:"hexString",get:function(){return this._hexString}},{key:"brightness",get:function(){return this._brightness}},{key:"isDark",get:function(){return this._isDark}},{key:"isLight",get:function(){return this._isLight}}]),t}();function u(t){return parseInt(t.replace("#",""),16)}var a=function(){function t(t){var e=this;void 0===t&&(t={}),this._widthUnits="px",this._heightUnits="px",this._huePosition=0,this._hueHeight=0,this._maxHue=0,this._inputIsNumber=!1,this._saturationWidth=0,this._isChoosing=!1,this._callbacks=[],this.width=0,this.height=0,this.hue=0,this.position={x:0,y:0},this.color=new h(0),this.backgroundColor=new h(0),this.hueColor=new h(0),this._onSaturationMouseDown=function(t){var i=e.$saturation.getBoundingClientRect(),o=n(t),s=o.x,r=o.y;e._isChoosing=!0,e._moveSelectorTo(s-i.left,r-i.top),e._updateColorFromPosition(),e._window.addEventListener("mouseup",e._onSaturationMouseUp),e._window.addEventListener("touchend",e._onSaturationMouseUp),e._window.addEventListener("mousemove",e._onSaturationMouseMove),e._window.addEventListener("touchmove",e._onSaturationMouseMove),t.preventDefault()},this._onSaturationMouseMove=function(t){var i=e.$saturation.getBoundingClientRect(),o=n(t);e._moveSelectorTo(o.x-i.left,o.y-i.top),e._updateColorFromPosition()},this._onSaturationMouseUp=function(){e._isChoosing=!1,e._window.removeEventListener("mouseup",e._onSaturationMouseUp),e._window.removeEventListener("touchend",e._onSaturationMouseUp),e._window.removeEventListener("mousemove",e._onSaturationMouseMove),e._window.removeEventListener("touchmove",e._onSaturationMouseMove)},this._onHueMouseDown=function(t){var i=e.$hue.getBoundingClientRect(),o=n(t).y;e._isChoosing=!0,e._moveHueTo(o-i.top),e._updateHueFromPosition(),e._window.addEventListener("mouseup",e._onHueMouseUp),e._window.addEventListener("touchend",e._onHueMouseUp),e._window.addEventListener("mousemove",e._onHueMouseMove),e._window.addEventListener("touchmove",e._onHueMouseMove),t.preventDefault()},this._onHueMouseMove=function(t){var i=e.$hue.getBoundingClientRect(),o=n(t);e._moveHueTo(o.y-i.top),e._updateHueFromPosition()},this._onHueMouseUp=function(){e._isChoosing=!1,e._window.removeEventListener("mouseup",e._onHueMouseUp),e._window.removeEventListener("touchend",e._onHueMouseUp),e._window.removeEventListener("mousemove",e._onHueMouseMove),e._window.removeEventListener("touchmove",e._onHueMouseMove)},this._window=t.window||window,this._document=this._window.document,this.$el=this._document.createElement("div"),this.$el.className="Scp",this.$el.innerHTML='\n      <div class="Scp-saturation">\n        <div class="Scp-brightness"></div>\n        <div class="Scp-sbSelector"></div>\n      </div>\n      <div class="Scp-hue">\n        <div class="Scp-hSelector"></div>\n      </div>\n    ',this.$saturation=this.$el.querySelector(".Scp-saturation"),this.$hue=this.$el.querySelector(".Scp-hue"),this.$sbSelector=this.$el.querySelector(".Scp-sbSelector"),this.$hSelector=this.$el.querySelector(".Scp-hSelector"),this.$saturation.addEventListener("mousedown",this._onSaturationMouseDown),this.$saturation.addEventListener("touchstart",this._onSaturationMouseDown),this.$hue.addEventListener("mousedown",this._onHueMouseDown),this.$hue.addEventListener("touchstart",this._onHueMouseDown),t.el&&this.appendTo(t.el),t.background&&this.setBackgroundColor(t.background),t.widthUnits&&(this._widthUnits=t.widthUnits),t.heightUnits&&(this._heightUnits=t.heightUnits),this.setSize(t.width||175,t.height||150),this.setColor(t.color)}var e=t.prototype;return e.appendTo=function(t){return"string"==typeof t?document.querySelector(t).appendChild(this.$el):t.appendChild(this.$el),this},e.remove=function(){this._callbacks=[],this._onSaturationMouseUp(),this._onHueMouseUp(),this.$saturation.removeEventListener("mousedown",this._onSaturationMouseDown),this.$saturation.removeEventListener("touchstart",this._onSaturationMouseDown),this.$hue.removeEventListener("mousedown",this._onHueMouseDown),this.$hue.removeEventListener("touchstart",this._onHueMouseDown),this.$el.parentNode&&this.$el.parentNode.removeChild(this.$el)},e.setColor=function(t){this._inputIsNumber=o(t),this.color.fromHex(t);var e=this.color.hsv,i=e.h,s=e.s,n=e.v;return isNaN(i)||(this.hue=i),this._moveSelectorTo(this._saturationWidth*s,(1-n)*this._hueHeight),this._moveHueTo((1-this.hue)*this._hueHeight),this._updateHue(),this},e.setSize=function(t,e){return this.width=t,this.height=e,this.$el.style.width=this.width+this._widthUnits,this.$el.style.height=this.height+this._heightUnits,this._saturationWidth=this.width-25,this.$saturation.style.width=this._saturationWidth+"px",this._hueHeight=this.height,this._maxHue=this._hueHeight-2,this},e.setBackgroundColor=function(t){return this.backgroundColor.fromHex(t),this.$el.style.padding="5px",this.$el.style.background=this.backgroundColor.hexString,this},e.setNoBackground=function(){return this.$el.style.padding="0px",this.$el.style.background="none",this},e.onChange=function(t){return this._callbacks.indexOf(t)<0&&(this._callbacks.push(t),t(this.getHexString())),this},e.getColor=function(){return this._inputIsNumber?this.getHexNumber():this.getHexString()},e.getHexString=function(){return this.color.hexString.toUpperCase()},e.getHexNumber=function(){return this.color.hex},e.getRGB=function(){return this.color.rgb},e.getHSV=function(){return this.color.hsv},e.isDark=function(){return this.color.isDark},e.isLight=function(){return this.color.isLight},e._moveSelectorTo=function(t,e){this.position.x=s(t,0,this._saturationWidth),this.position.y=s(e,0,this._hueHeight),this.$sbSelector.style.transform="translate("+this.position.x+"px, "+this.position.y+"px)"},e._updateColorFromPosition=function(){this.color.fromHsv({h:this.hue,s:this.position.x/this._saturationWidth,v:1-this.position.y/this._hueHeight}),this._updateColor()},e._moveHueTo=function(t){this._huePosition=s(t,0,this._maxHue),this.$hSelector.style.transform="translateY("+this._huePosition+"px)"},e._updateHueFromPosition=function(){var t=this.getHSV();this.hue=1-this._huePosition/this._maxHue,this.color.fromHsv({h:this.hue,s:t.s,v:t.v}),this._updateHue()},e._updateHue=function(){this.hueColor.fromHsv({h:this.hue,s:1,v:1}),this.$saturation.style.background="linear-gradient(to right, #fff, "+this.hueColor.hexString+")",this._updateColor()},e._updateColor=function(){this.$sbSelector.style.background=this.getHexString(),this.$sbSelector.style.borderColor=this.isDark()?"#fff":"#000",this._triggerChange()},e._triggerChange=function(){var t=this;this._callbacks.forEach(function(e){return e(t.getHexString())})},i(t,[{key:"isChoosing",get:function(){return this._isChoosing}}]),t}();(0,insert_css.insertCss)(".Scp{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative}.Scp-saturation{position:relative;height:100%;background:linear-gradient(90deg,#fff,red);float:left;margin-right:5px}.Scp-brightness{width:100%;height:100%;background:linear-gradient(hsla(0,0%,100%,0),#000)}.Scp-sbSelector{border:2px solid #fff;position:absolute;width:14px;height:14px;background:#fff;border-radius:10px;top:-7px;left:-7px;box-sizing:border-box;z-index:10}.Scp-hue{width:20px;height:100%;position:relative;float:left;background:linear-gradient(red,#f0f 17%,#00f 34%,#0ff 50%,#0f0 67%,#ff0 84%,red)}.Scp-hSelector{position:absolute;background:#fff;border-bottom:1px solid #000;right:-3px;width:10px;height:2px}");/* harmony default export */ const simple_color_picker_module = (a);
//# sourceMappingURL=simple-color-picker.module.js.map

;// CONCATENATED MODULE: ./src/components/value.js


var buildValueStyles = function buildValueStyles(background2, text2, width, left) {
  return {
    body: {
      position: 'absolute',
      backgroundColor: background2,
      paddingLeft: '1.5%',
      height: 20,
      width: width,
      display: 'inline-block',
      overflow: 'hidden',
      right: !left ? 0 : undefined,
      cursor: 'auto'
    },
    text: {
      color: text2,
      display: 'inline-block',
      MozUserSelect: 'text',
      cursor: 'text',
      overflow: 'hidden',
      lineHeight: '20px',
      wordBreak: 'break-all',
      height: 20
    }
  };
};
var Value = function Value(_ref) {
  var theme = _ref.theme,
    text = _ref.text,
    width = _ref.width,
    left = _ref.left,
    onDoubleClick = _ref.onDoubleClick;
  var styles = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useMemo)(function () {
    return buildValueStyles(theme.background2, theme.text2, width, left);
  }, [theme.background2, theme.text2, width, left]);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
    style: styles.body,
    onDoubleClick: onDoubleClick
  }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
    style: styles.text
  }, text));
};
var EnhancedValue = withTheme(Value);
/* harmony default export */ const value = (EnhancedValue);
;// CONCATENATED MODULE: ./src/components/color.js
function color_typeof(o) { "@babel/helpers - typeof"; return color_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, color_typeof(o); }
function color_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function color_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, color_toPropertyKey(descriptor.key), descriptor); } }
function color_createClass(Constructor, protoProps, staticProps) { if (protoProps) color_defineProperties(Constructor.prototype, protoProps); if (staticProps) color_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function color_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) color_setPrototypeOf(subClass, superClass); }
function color_setPrototypeOf(o, p) { color_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return color_setPrototypeOf(o, p); }
function color_createSuper(Derived) { var hasNativeReflectConstruct = color_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = color_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = color_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return color_possibleConstructorReturn(this, result); }; }
function color_possibleConstructorReturn(self, call) { if (call && (color_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return color_assertThisInitialized(self); }
function color_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function color_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function color_getPrototypeOf(o) { color_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return color_getPrototypeOf(o); }
function color_defineProperty(obj, key, value) { key = color_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function color_toPropertyKey(t) { var i = color_toPrimitive(t, "string"); return "symbol" == color_typeof(i) ? i : String(i); }
function color_toPrimitive(t, r) { if ("object" != color_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != color_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function color_slicedToArray(arr, i) { return color_arrayWithHoles(arr) || color_iterableToArrayLimit(arr, i) || color_unsupportedIterableToArray(arr, i) || color_nonIterableRest(); }
function color_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function color_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return color_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return color_arrayLikeToArray(o, minLen); }
function color_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function color_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function color_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var arrayToRgb = function arrayToRgb(arr) {
  var _arr$map = arr.map(function (x) {
      return Math.round(x * 255);
    }),
    _arr$map2 = color_slicedToArray(_arr$map, 3),
    r = _arr$map2[0],
    g = _arr$map2[1],
    b = _arr$map2[2];
  return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
};
var colorFormatters = {
  rgb: function rgb(colorPicker) {
    var _colorPicker$getRGB = colorPicker.getRGB(),
      r = _colorPicker$getRGB.r,
      g = _colorPicker$getRGB.g,
      b = _colorPicker$getRGB.b;
    return "rgb(".concat(Math.round(r * 255), ", ").concat(Math.round(g * 255), ", ").concat(Math.round(b * 255), ")");
  },
  hex: function hex(colorPicker) {
    return colorPicker.getHexString();
  },
  array: function array(colorPicker) {
    var _colorPicker$getRGB2 = colorPicker.getRGB(),
      r = _colorPicker$getRGB2.r,
      g = _colorPicker$getRGB2.g,
      b = _colorPicker$getRGB2.b;
    return [r, g, b].map(function (x) {
      return (x / 255).toFixed(2);
    });
  }
};

// Normalizes all input color strings to hex number
var colorParsers = {
  rgb: function rgb(color) {
    var _color$replace$replac = color.replace('rgb(', '').replace(' ', '').replace(')', '').split(',').map(function (x) {
        return parseInt(x, 10);
      }),
      _color$replace$replac2 = color_slicedToArray(_color$replace$replac, 3),
      r = _color$replace$replac2[0],
      g = _color$replace$replac2[1],
      b = _color$replace$replac2[2];
    return (r << 16) + (g << 8) + b;
  },
  hex: function hex(color) {
    return parseInt(color.replace('#', ''), 16);
  },
  array: function array(color) {
    var _color$map = color.map(function (x) {
        return Math.round(x * 255);
      }),
      _color$map2 = color_slicedToArray(_color$map, 3),
      r = _color$map2[0],
      g = _color$map2[1],
      b = _color$map2[2];
    return (r << 16) + (g << 8) + b;
  }
};
var Color = /*#__PURE__*/function (_React$Component) {
  color_inherits(Color, _React$Component);
  var _super = color_createSuper(Color);
  function Color() {
    var _this;
    color_classCallCheck(this, Color);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    color_defineProperty(color_assertThisInitialized(_this), "colorpickerContainer", /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createRef());
    color_defineProperty(color_assertThisInitialized(_this), "state", {
      colorHovered: false,
      pickerHovered: false
    });
    color_defineProperty(color_assertThisInitialized(_this), "lastColor", null);
    color_defineProperty(color_assertThisInitialized(_this), "formatColor", function () {
      return colorFormatters[_this.props.format](_this.picker);
    });
    color_defineProperty(color_assertThisInitialized(_this), "getStyles", function () {
      return {
        colorDisplay: {
          position: 'relative',
          display: 'inline-block',
          width: '12.5%',
          height: 20,
          backgroundColor: _this.props.format === 'array' ? arrayToRgb(_this.props.value) : _this.props.value
        },
        picker: {
          position: 'absolute',
          top: '20%',
          paddingTop: 20,
          left: '38%',
          bottom: '20%',
          right: '10%',
          height: 100,
          width: 100,
          zIndex: 8,
          display: _this.state.colorHovered || _this.state.pickerHovered ? undefined : 'none',
          cursor: 'default'
        }
      };
    });
    color_defineProperty(color_assertThisInitialized(_this), "render", function () {
      var styles = _this.getStyles();
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
        style: styles.colorDisplay,
        onMouseEnter: function onMouseEnter() {
          return _this.setState({
            colorHovered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this.setState({
            colorHovered: false
          });
        }
      }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
        ref: _this.colorpickerContainer,
        style: styles.picker,
        onMouseEnter: function onMouseEnter() {
          return _this.setState({
            pickerHovered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this.setState({
            pickerHovered: false
          });
        }
      }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(value, {
        text: _this.props.value,
        width: "46%"
      }));
    });
    return _this;
  }
  color_createClass(Color, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.picker = new simple_color_picker_module({
        el: this.colorpickerContainer.current,
        color: this.props.value,
        background: this.props.theme.background1,
        width: 125,
        height: 100
      });
      this.picker.onChange(function () {
        var formattedNewColor = _this2.formatColor();
        if (formattedNewColor !== _this2.props.value) {
          _this2.lastColor = formattedNewColor;
          _this2.props.onChange(formattedNewColor);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.picker && this.props.value !== this.lastColor) {
        console.log('parsing');
        var parsedColor = colorParsers[this.props.format](this.props.value);
        this.picker.setColor(parsedColor);
      }
    }
  }]);
  return Color;
}((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Component);
/* harmony default export */ const color = (withSettingState()(Color));
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/utils/namespace.js
var CONTEXT_NAMESPACE = '__react_css_component_cache';
var ID_NAMESPACE = '__react_css_component_id-';
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/components/StyleCacheProvider.js
var StyleCacheProvider_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function StyleCacheProvider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function StyleCacheProvider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StyleCacheProvider_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StyleCacheProvider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var StyleCacheProvider = function (_Component) {
  StyleCacheProvider_inherits(StyleCacheProvider, _Component);

  function StyleCacheProvider(props, context) {
    StyleCacheProvider_classCallCheck(this, StyleCacheProvider);

    var _this = StyleCacheProvider_possibleConstructorReturn(this, (StyleCacheProvider.__proto__ || Object.getPrototypeOf(StyleCacheProvider)).call(this, props, context));

    _this.cache = {};
    return _this;
  }

  StyleCacheProvider_createClass(StyleCacheProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return StyleCacheProvider_defineProperty({}, CONTEXT_NAMESPACE, this.cache);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return StyleCacheProvider;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_.Component);

/* harmony default export */ const components_StyleCacheProvider = ((/* unused pure expression or super */ null && (StyleCacheProvider)));


StyleCacheProvider.childContextTypes = StyleCacheProvider_defineProperty({}, CONTEXT_NAMESPACE, (prop_types_default()).object);
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/utils/appendStyle.js
function appendStyle(id, css) {
  if (!document.head.querySelector('#' + id)) {
    var node = document.createElement('style');
    node.textContent = css;
    node.type = 'text/css';
    node.id = id;

    document.head.appendChild(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/components/UniversalStyle.js
var UniversalStyle_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UniversalStyle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function UniversalStyle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UniversalStyle_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UniversalStyle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var idCache = {};

var UniversalStyle = function (_Component) {
  UniversalStyle_inherits(UniversalStyle, _Component);

  function UniversalStyle(props, context) {
    UniversalStyle_classCallCheck(this, UniversalStyle);

    var _this = UniversalStyle_possibleConstructorReturn(this, (UniversalStyle.__proto__ || Object.getPrototypeOf(UniversalStyle)).call(this, props, context));

    if (!idCache[props.css]) {
      // generating a unique style id to prevent duplicate nodes
      // within client-sides document.head
      var uniqueId = Object.keys(idCache).length;
      idCache[props.css] = ID_NAMESPACE + uniqueId;
    }

    if (context[CONTEXT_NAMESPACE]) {
      // add the rendered css to the cache to only render once during SSR
      if (!context[CONTEXT_NAMESPACE][props.css]) {
        context[CONTEXT_NAMESPACE][props.css] = true;
        _this.isFirstOccurence = true;
      }
    } else {
      // if no cache is provided, render multiple times
      _this.isFirstOccurence = true;
    }
    return _this;
  }

  UniversalStyle_createClass(UniversalStyle, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.isFirstOccurence) {
        var css = this.props.css;
        var id = idCache[css];

        // inject the style into the head if it unmounts
        // to ensure its existence for other instances
        // using the same CSS rendered
        appendStyle(id, css);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      // only actually render the style node
      // if its the first occurence
      if (this.isFirstOccurence) {
        return (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.createElement)('style', {
          dangerouslySetInnerHTML: { __html: this.props.css }
        });
      }

      return null;
    }
  }]);

  return UniversalStyle;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_.Component);

/* harmony default export */ const components_UniversalStyle = ((/* unused pure expression or super */ null && (UniversalStyle)));


UniversalStyle.contextTypes = UniversalStyle_defineProperty({}, CONTEXT_NAMESPACE, (prop_types_default()).object);
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/utils/isDOMReady.js
function isDOMReady() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && document.head;
}
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/components/ClientStyle.js
var ClientStyle_createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ClientStyle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ClientStyle_possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ClientStyle_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ClientStyle_idCache = {};

var ClientStyle = function (_Component) {
  ClientStyle_inherits(ClientStyle, _Component);

  function ClientStyle(props, context) {
    ClientStyle_classCallCheck(this, ClientStyle);

    var _this = ClientStyle_possibleConstructorReturn(this, (ClientStyle.__proto__ || Object.getPrototypeOf(ClientStyle)).call(this, props, context));

    if (!ClientStyle_idCache[props.css]) {
      // generating a unique style id to prevent duplicate nodes
      // within client-sides document.head
      var uniqueId = Object.keys(ClientStyle_idCache).length;
      ClientStyle_idCache[props.css] = ID_NAMESPACE + uniqueId;
    }

    if (isDOMReady()) {
      appendStyle(ClientStyle_idCache[props.css], props.css);
      _this.isReady = true;
    }
    return _this;
  }

  ClientStyle_createClass(ClientStyle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.isReady && isDOMReady()) {
        appendStyle(ClientStyle_idCache[this.props.css], this.props.css);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ClientStyle;
}(external_root_React_commonjs_react_commonjs2_react_amd_react_.Component);

/* harmony default export */ const components_ClientStyle = (ClientStyle);
;// CONCATENATED MODULE: ./node_modules/react-css-component/es/index.js





;// CONCATENATED MODULE: ./src/components/EditableValue.js
function EditableValue_typeof(o) { "@babel/helpers - typeof"; return EditableValue_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, EditableValue_typeof(o); }
function EditableValue_slicedToArray(arr, i) { return EditableValue_arrayWithHoles(arr) || EditableValue_iterableToArrayLimit(arr, i) || EditableValue_unsupportedIterableToArray(arr, i) || EditableValue_nonIterableRest(); }
function EditableValue_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function EditableValue_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return EditableValue_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EditableValue_arrayLikeToArray(o, minLen); }
function EditableValue_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function EditableValue_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function EditableValue_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function EditableValue_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EditableValue_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EditableValue_ownKeys(Object(t), !0).forEach(function (r) { EditableValue_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EditableValue_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function EditableValue_defineProperty(obj, key, value) { key = EditableValue_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function EditableValue_toPropertyKey(t) { var i = EditableValue_toPrimitive(t, "string"); return "symbol" == EditableValue_typeof(i) ? i : String(i); }
function EditableValue_toPrimitive(t, r) { if ("object" != EditableValue_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != EditableValue_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var EditableValue = function EditableValue(_ref) {
  var theme = _ref.theme,
    initialValue = _ref.initialValue,
    width = _ref.width,
    left = _ref.left,
    onSubmit = _ref.onSubmit;
  var style = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useMemo)(function () {
    var baseStyles = buildValueStyles(theme.background2, theme.text2, width, left);
    return EditableValue_objectSpread(EditableValue_objectSpread(EditableValue_objectSpread({}, baseStyles.body), baseStyles.text), {}, {
      height: 17
    });
  }, [theme.background2, theme.text2, width, left]);
  var _useState = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useState)(initialValue),
    _useState2 = EditableValue_slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  // Focus the input when it is mounted
  var inputRef = external_root_React_commonjs_react_commonjs2_react_amd_react_default().useRef(null);
  (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useEffect)(function () {
    inputRef.current.focus();
  }, []);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("input", {
    ref: inputRef,
    type: "text",
    style: style,
    onKeyDown: function onKeyDown(evt) {
      if (evt.key === 'Enter') {
        onSubmit(value);
      } else if (evt.key === 'Escape') {
        onSubmit(initialValue);
      }
    },
    onChange: function onChange(evt) {
      return setValue(evt.target.value);
    },
    value: value
  });
};
;// CONCATENATED MODULE: ./src/components/styles/range.js
/* harmony default export */ const range = (function (theme, id) {
  return "\n.control-panel-range-".concat(id, "::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 20px;\n  cursor: ew-resize;\n  background: ").concat(theme.background2, ";\n}\n\n.control-panel-range-").concat(id, "::-webkit-slider-thumb {\n  height: 20px;\n  width: 10px;\n  background: ").concat(theme.foreground1, ";\n  cursor: ew-resize;\n  -webkit-appearance: none;\n  margin-top: 0px;\n}\n\n.control-panel-range-").concat(id, ":focus::-webkit-slider-runnable-track {\n  background: ").concat(theme.background2, ";\n  outline: none;\n}\n\n.control-panel-range-").concat(id, "::-moz-range-track {\n  width: 100%;\n  height: 20px;\n  cursor: ew-resize;\n  background: ").concat(theme.background2, ";\n}\n\n.control-panel-range-").concat(id, "::-moz-range-thumb {\n  border: 0px solid rgba(0, 0, 0, 0);\n  height: 20px;\n  width: 10px;\n  border-radius: 0px;\n  background: ").concat(theme.foreground1, ";\n  cursor: ew-resize;\n}\n\n.control-panel-range-").concat(id, "::-ms-track {\n  width: 100%;\n  height: 20px;\n  cursor: ew-resize;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\n\n.control-panel-range-").concat(id, "::-ms-fill-lower {\n  background: ").concat(theme.foreground1, ";\n}\n\n.control-panel-range-").concat(id, "::-ms-fill-upper {\n  background: ").concat(theme.foreground1, ";\n}\n\n.control-panel-range-").concat(id, "::-ms-thumb {\n  width: 10px;\n  border-radius: 0px;\n  background: ").concat(theme.foreground1, ";\n  cursor: ew-resize;\n  height: 20px;\n}\n\n.control-panel-range-").concat(id, ":focus::-ms-fill-lower {\n  background: ").concat(theme.foreground1, ";\n  outline: none;\n}\n\n.control-panel-range-").concat(id, ":focus::-ms-fill-upper {\n  background: ").concat(theme.foreground1, ";\n  outline: none;\n}\n\n.control-panel-range-").concat(id, " {\n  -webkit-appearance: none;\n  width: 47.5%;\n  margin: 0px 0;\n  margin-top: 2px;\n}\n\n.control-panel-range-").concat(id, ":focus {\n  outline: none;\n}\n");
});
;// CONCATENATED MODULE: ./src/components/range.js
var range_excluded = ["scale", "steps", "onChange", "theme"];
function range_slicedToArray(arr, i) { return range_arrayWithHoles(arr) || range_iterableToArrayLimit(arr, i) || range_unsupportedIterableToArray(arr, i) || range_nonIterableRest(); }
function range_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function range_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return range_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return range_arrayLikeToArray(o, minLen); }
function range_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function range_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function range_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function range_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = range_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function range_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










var getLogDisplayOpts = withScalerFunctions(function (_ref) {
  var min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    scaleValue = _ref.scaleValue,
    scaleValueInverse = _ref.scaleValueInverse;
  // `value` is the logarithmic value that the user cares about.  We convert it into a value
  // from 1 to 100 in order to pass it to the slider.
  var sliderVal = scaleValueInverse(numericOrDefaultElse(value, function () {
    return scaleValue((min + max) / 2);
  }));
  if (sliderVal * scaleValueInverse(max) < 0) {
    throwLogRangeError(sliderVal);
  }
  return {
    min: 0,
    max: 100,
    step: 1,
    logVal: value,
    sliderVal: sliderVal,
    scaleValue: scaleValue
  };
});
var getNormalDisplayOpts = createNormalDisplayOptsGetter(function (min, max, value) {
  return numericOrDefault(value, (min + max) / 2);
});
var InnerRange = function InnerRange(_ref2) {
  var scale = _ref2.scale,
    steps = _ref2.steps,
    onChange = _ref2.onChange,
    theme = _ref2.theme,
    props = range_objectWithoutProperties(_ref2, range_excluded);
  var id = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useRef)(esm_browser_v4());
  var css = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useMemo)(function () {
    return range(theme, id.current);
  }, [theme]);
  validateStepParams(props.step, steps);
  var _useState = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useState)(null),
    _useState2 = range_slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _ref3 = (scale === 'log' ? getLogDisplayOpts : getNormalDisplayOpts)(props),
    min = _ref3.min,
    max = _ref3.max,
    step = _ref3.step,
    logVal = _ref3.logVal,
    sliderVal = _ref3.sliderVal,
    scaleValue = _ref3.scaleValue;
  // use `steps` if provided
  var processedStep = is_numeric_default()(steps) ? (max - min) / steps : step;
  var handleChange = (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useCallback)(function (e) {
    // We take the value from the slider (range 1 to 100) and scale it into its logarithmic
    // representation before passing it into the state.
    onChange(scaleValue(parseFloat(e.target.value)));
  }, [scaleValue, onChange]);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(components_ClientStyle, {
    css: css
  }), /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("input", {
    className: "control-panel-range-".concat(id.current),
    type: "range",
    value: sliderVal,
    min: min,
    max: max,
    step: processedStep,
    onChange: handleChange
  }), isEditing ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(EditableValue, {
    initialValue: props.value,
    onSubmit: function onSubmit(newValue) {
      var parsedValue = parseFloat(newValue);
      if (isNaN(parsedValue)) {
        setIsEditing(false);
        return;
      }
      onChange(parsedValue);
      setIsEditing(false);
    },
    theme: theme,
    width: "11%"
  }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(value, {
    text: logVal,
    width: "11%",
    onDoubleClick: function onDoubleClick() {
      return setIsEditing(true);
    }
  }));
};
/* harmony default export */ const components_range = (withErrorHandler(withSettingState()(InnerRange)));
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/components/styles/interval.css
var interval = __webpack_require__(387);
;// CONCATENATED MODULE: ./src/components/styles/interval.css

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(interval/* default */.Z, options);




       /* harmony default export */ const styles_interval = (interval/* default */.Z && interval/* default */.Z.locals ? interval/* default */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/components/interval.js
var interval_excluded = ["scale", "steps", "theme"];
function interval_typeof(o) { "@babel/helpers - typeof"; return interval_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, interval_typeof(o); }
function interval_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = interval_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function interval_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function interval_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function interval_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, interval_toPropertyKey(descriptor.key), descriptor); } }
function interval_createClass(Constructor, protoProps, staticProps) { if (protoProps) interval_defineProperties(Constructor.prototype, protoProps); if (staticProps) interval_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function interval_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) interval_setPrototypeOf(subClass, superClass); }
function interval_setPrototypeOf(o, p) { interval_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return interval_setPrototypeOf(o, p); }
function interval_createSuper(Derived) { var hasNativeReflectConstruct = interval_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = interval_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = interval_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return interval_possibleConstructorReturn(this, result); }; }
function interval_possibleConstructorReturn(self, call) { if (call && (interval_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return interval_assertThisInitialized(self); }
function interval_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function interval_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function interval_getPrototypeOf(o) { interval_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return interval_getPrototypeOf(o); }
function interval_defineProperty(obj, key, value) { key = interval_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function interval_toPropertyKey(t) { var i = interval_toPrimitive(t, "string"); return "symbol" == interval_typeof(i) ? i : String(i); }
function interval_toPrimitive(t, r) { if ("object" != interval_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != interval_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var interval_getLogDisplayOpts = withScalerFunctions(function (_ref) {
  var min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    value = _ref.value,
    scaleValue = _ref.scaleValue,
    scaleValueInverse = _ref.scaleValueInverse;
  // Scale the values down from their logarithmic represenations into the range used by the slider
  var sliderVals = [scaleValueInverse(numericOrDefaultElse(value[0], function () {
    return min + (max - min) * 0.25;
  })), scaleValueInverse(numericOrDefaultElse(value[1], function () {
    return min + (max - min) * 0.75;
  }))];
  var scaledMax = scaleValue(max);
  if (scaleValue(sliderVals[0]) * scaledMax <= 0 || scaleValue(sliderVals[1]) * scaledMax <= 0) {
    throwLogRangeError("[".concat(sliderVals[0], ",").concat(sliderVals[1], "]"));
  }
  return {
    min: 0,
    max: 100,
    step: 1,
    sliderVal: sliderVals,
    logVal: value,
    scaleValue: scaleValue
  };
});
var interval_getNormalDisplayOpts = createNormalDisplayOptsGetter(function (min, max, value) {
  return [numericOrDefault(value[0], (min + max) * 0.25), numericOrDefault(value[1], (min + max) * 0.75)];
});
var Range = /*#__PURE__*/function (_React$Component) {
  interval_inherits(Range, _React$Component);
  var _super = interval_createSuper(Range);
  function Range() {
    var _this;
    interval_classCallCheck(this, Range);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    interval_defineProperty(interval_assertThisInitialized(_this), "input", /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createRef());
    interval_defineProperty(interval_assertThisInitialized(_this), "state", {
      activeIndex: -1,
      value: null,
      min: null,
      max: null,
      step: null,
      isEditingLeft: false,
      isEditingRight: false
    });
    /**
     * Gets mouse position in page coords relative to the container
     */
    interval_defineProperty(interval_assertThisInitialized(_this), "mouseX", function (ev) {
      return ev.pageX - _this.input.current.getBoundingClientRect().left;
    });
    interval_defineProperty(interval_assertThisInitialized(_this), "calculateFraction", function (evt, value, min, max) {
      return {
        fraction: clamp(_this.mouseX(evt) / _this.input.current.offsetWidth, 0, 1),
        lofrac: (clamp(value[0], min, max) - min) / (max - min),
        hifrac: (clamp(value[1], min, max) - min) / (max - min)
      };
    });
    interval_defineProperty(interval_assertThisInitialized(_this), "setValue", function (oldValue, newValue, activeIndex, clampToExtremes) {
      if (activeIndex === -1) {
        return;
      }

      // Make sure it doesn't overrun the slider or pass the other side
      var clampTo = activeIndex === 0 ? [clampToExtremes ? _this.props.min : -Infinity, oldValue[1]] : [oldValue[0], clampToExtremes ? _this.props.max : Infinity];
      oldValue[activeIndex] = clamp(newValue, clampTo[0], clampTo[1]);
      _this.props.onChange(oldValue);
    });
    interval_defineProperty(interval_assertThisInitialized(_this), "setIsEditingLeft", function (isEditingLeft) {
      return _this.setState({
        isEditingLeft: isEditingLeft
      });
    });
    interval_defineProperty(interval_assertThisInitialized(_this), "setIsEditingRight", function (isEditingRight) {
      return _this.setState({
        isEditingRight: isEditingRight
      });
    });
    return _this;
  }
  interval_createClass(Range, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var mouseHandlerWrapper = function mouseHandlerWrapper(fn) {
        return function (evt) {
          if (!_this2.state.dragging) {
            return;
          }
          var _this2$computedScaleI = _this2.computedScaleInfo,
            value = _this2$computedScaleI.value,
            min = _this2$computedScaleI.min,
            max = _this2$computedScaleI.max,
            step = _this2$computedScaleI.step,
            scaleValue = _this2$computedScaleI.scaleValue;
          var _this2$calculateFract = _this2.calculateFraction(evt, value, min, max),
            fraction = _this2$calculateFract.fraction,
            hifrac = _this2$calculateFract.hifrac,
            lofrac = _this2$calculateFract.lofrac;

          // Clip against the other bound:
          var clippedFraction = _this2.state.activeIndex === 0 ? Math.min(hifrac, fraction) : Math.max(lofrac, fraction);

          // Compute and quantize the new value:
          var newValue = scaleValue(min + Math.round((max - min) * clippedFraction / step) * step);
          _this2.setValue(value, newValue, _this2.state.activeIndex, true);
          fn && fn();
        };
      };

      // Install event listeners on the document for mouse movement and release
      document.addEventListener('mousemove', mouseHandlerWrapper());
      document.addEventListener('mouseup', mouseHandlerWrapper(function () {
        return _this2.setState({
          dragging: false,
          activeIndex: -1
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        scale = _this$props.scale,
        steps = _this$props.steps,
        theme = _this$props.theme,
        props = interval_objectWithoutProperties(_this$props, interval_excluded);
      var _ref2 = (scale === 'log' ? interval_getLogDisplayOpts : interval_getNormalDisplayOpts)(props),
        min = _ref2.min,
        max = _ref2.max,
        step = _ref2.step,
        sliderVal = _ref2.sliderVal,
        logVal = _ref2.logVal,
        scaleValue = _ref2.scaleValue;
      validateStepParams(props.step, steps);

      // These values need to be available for the global mouse event listeners, so we set them
      // as a class property.  This doesn't trigger re-renderings since we're not using `setState`.
      this.computedScaleInfo = {
        value: logVal,
        min: min,
        max: max,
        step: is_numeric_default()(steps) ? (max - min) / steps : step,
        scaleValue: scaleValue
      };
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Fragment, null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
        className: "control-panel-interval",
        style: {
          backgroundColor: theme.background2
        },
        ref: this.input,
        onMouseDown: function onMouseDown(evt) {
          _this3.setState({
            dragging: true
          });

          // Figure out which side is being clicked and adjust the active index accodingly
          var _this3$calculateFract = _this3.calculateFraction(evt, sliderVal, min, max),
            fraction = _this3$calculateFract.fraction,
            hifrac = _this3$calculateFract.hifrac,
            lofrac = _this3$calculateFract.lofrac;

          // This is just for making decisions, so perturb it ever so slightly just in case the
          // bounds are numerically equal.
          var lodiff = Math.abs(lofrac - Math.abs(max - min) * 1e-15 - fraction);
          var hidiff = Math.abs(hifrac + Math.abs(max - min) * 1e-15 - fraction);

          // Determine which one is closer
          _this3.setState({
            activeIndex: lodiff < hidiff ? 0 : 1
          });
        }
      }, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("span", {
        className: "control-panel-interval-handle",
        style: {
          left: clamp((sliderVal[0] - min) / (max - min) * 100, 0, 100) + '%',
          right: clamp(100 - (sliderVal[1] - min) / (max - min) * 100, 0, 100) + '%',
          backgroundColor: theme.foreground1
        }
      })), this.state.isEditingLeft ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(EditableValue, {
        left: true,
        initialValue: logVal[0],
        onSubmit: function onSubmit(newValue) {
          var parsedValue = parseFloat(newValue);
          if (isNaN(parsedValue)) {
            _this3.setIsEditingLeft(false);
            return;
          }
          var oldValue = _this3.computedScaleInfo.value;
          parsedValue = Math.min(parsedValue, oldValue[1]);
          _this3.setValue(oldValue, parsedValue, 0, false);
          _this3.setIsEditingLeft(false);
        },
        theme: theme,
        width: "11%"
      }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(value, {
        text: logVal[0],
        width: "11%",
        left: true,
        onDoubleClick: function onDoubleClick() {
          return _this3.setIsEditingLeft(true);
        }
      }), this.state.isEditingRight ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(EditableValue, {
        initialValue: logVal[1],
        onSubmit: function onSubmit(newValue) {
          var parsedValue = parseFloat(newValue);
          if (isNaN(parsedValue)) {
            _this3.setIsEditingRight(false);
            return;
          }
          var oldValue = _this3.computedScaleInfo.value;
          parsedValue = Math.max(parsedValue, oldValue[0]);
          _this3.setValue(oldValue, parsedValue, 1, false);
          _this3.setIsEditingRight(false);
        },
        theme: theme,
        width: "11%"
      }) : /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(value, {
        text: logVal[1],
        width: "11%",
        onDoubleClick: function onDoubleClick() {
          return _this3.setIsEditingRight(true);
        }
      }));
    }
  }]);
  return Range;
}((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Component);
/* harmony default export */ const components_interval = (withErrorHandler(withSettingState()(Range)));
;// CONCATENATED MODULE: ./src/components/custom.js
var custom_excluded = ["Comp", "renderContainer"];
function custom_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = custom_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function custom_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var CustomComponentInner = function CustomComponentInner(_ref) {
  var Comp = _ref.Comp,
    renderContainer = _ref.renderContainer,
    props = custom_objectWithoutProperties(_ref, custom_excluded);
  return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(Comp, props);
};

/**
 * Takes a prop, `Comp`, which is a component that will be rendered as a control panel input.
 *
 * If the `renderContainer` prop is `true` (default), a `Container` will be rendered as the parent
 * of this element.  That gives you the label on the left and assumes your styling is going to be
 * pretty close to that of the rest of control-panel's imputs.  If you have a highly custom
 * component, you may want to instead handle that all yourself in which you should pass
 * `renderContainer={false}` to `CustomComponent`.
 *
 * The `Comp` child will be passed the following props:
 * - `theme`
 * - `value`
 * - `onChange`
 */
var CustomComponent = compose(withSettingState(), withErrorHandler)(CustomComponentInner);
/* harmony default export */ const custom = (CustomComponent);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/components/styles/base.css
var base = __webpack_require__(276);
;// CONCATENATED MODULE: ./src/components/styles/base.css

      
      
      
      
      
      
      
      
      

var base_options = {};

base_options.styleTagTransform = (styleTagTransform_default());
base_options.setAttributes = (setAttributesWithoutAttributes_default());

      base_options.insert = insertBySelector_default().bind(null, "head");
    
base_options.domAPI = (styleDomAPI_default());
base_options.insertStyleElement = (insertStyleElement_default());

var base_update = injectStylesIntoStyleTag_default()(base/* default */.Z, base_options);




       /* harmony default export */ const styles_base = (base/* default */.Z && base/* default */.Z.locals ? base/* default */.Z.locals : undefined);

// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/components/styles/color.css
var styles_color = __webpack_require__(162);
;// CONCATENATED MODULE: ./src/components/styles/color.css

      
      
      
      
      
      
      
      
      

var color_options = {};

color_options.styleTagTransform = (styleTagTransform_default());
color_options.setAttributes = (setAttributesWithoutAttributes_default());

      color_options.insert = insertBySelector_default().bind(null, "head");
    
color_options.domAPI = (styleDomAPI_default());
color_options.insertStyleElement = (insertStyleElement_default());

var color_update = injectStylesIntoStyleTag_default()(styles_color/* default */.Z, color_options);




       /* harmony default export */ const components_styles_color = (styles_color/* default */.Z && styles_color/* default */.Z.locals ? styles_color/* default */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/index.js
var src_excluded = ["type", "label"];
function src_extends() { src_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return src_extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || src_unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function src_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return src_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return src_arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return src_arrayLikeToArray(arr); }
function src_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function src_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = src_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function src_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function src_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function src_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, src_toPropertyKey(descriptor.key), descriptor); } }
function src_createClass(Constructor, protoProps, staticProps) { if (protoProps) src_defineProperties(Constructor.prototype, protoProps); if (staticProps) src_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function src_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) src_setPrototypeOf(subClass, superClass); }
function src_setPrototypeOf(o, p) { src_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return src_setPrototypeOf(o, p); }
function src_createSuper(Derived) { var hasNativeReflectConstruct = src_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = src_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = src_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return src_possibleConstructorReturn(this, result); }; }
function src_possibleConstructorReturn(self, call) { if (call && (src_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return src_assertThisInitialized(self); }
function src_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function src_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function src_getPrototypeOf(o) { src_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return src_getPrototypeOf(o); }
function src_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function src_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? src_ownKeys(Object(t), !0).forEach(function (r) { src_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : src_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function src_defineProperty(obj, key, value) { key = src_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function src_toPropertyKey(t) { var i = src_toPrimitive(t, "string"); return "symbol" == src_typeof(i) ? i : String(i); }
function src_toPrimitive(t, r) { if ("object" != src_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != src_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function src_typeof(o) { "@babel/helpers - typeof"; return src_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, src_typeof(o); }































var settingTypeMapping = {
  range: components_range,
  text: components_text,
  checkbox: components_checkbox,
  color: color,
  button: components_button,
  select: components_select,
  multibox: multibox,
  interval: components_interval,
  custom: custom
};
var VALID_POSITIONS = ['top-right', 'top-left', 'bottom-right', 'bottom-left'];

/**
 *
 * @param {string | { left?: number, right?: number, bottom?: number, top?: number }} position
 */
var parsePositionPropToOffsets = function parsePositionPropToOffsets(position) {
  if (src_typeof(position) === 'object') {
    return position;
  }
  if (!position) {
    return {};
  }
  return src_objectSpread(src_objectSpread(src_objectSpread(src_objectSpread({}, position.includes('top') ? {
    top: 8
  } : {}), position.includes('left') ? {
    left: 8
  } : {}), position.includes('right') ? {
    right: 8
  } : {}), position.includes('bottom') ? {
    bottom: 8
  } : {});
};
var maybeSnapToGrid = function maybeSnapToGrid(pos, snapToGrid) {
  if (!snapToGrid || typeof snapToGrid !== 'number') {
    return pos;
  }
  var snap = function snap(v, grid) {
    return Math.round(v / grid) * grid;
  };
  for (var key in pos) {
    pos[key] = snap(pos[key], snapToGrid);
  }
  return pos;
};
var DragHelper = function DragHelper(_ref) {
  var handleMouseDrag = _ref.handleMouseDrag,
    handleMouseUp = _ref.handleMouseUp;
  (0,external_root_React_commonjs_react_commonjs2_react_amd_react_.useEffect)(function () {
    document.addEventListener('mousemove', handleMouseDrag);
    document.addEventListener('mouseup', handleMouseUp);
    return function () {
      document.removeEventListener('mousemove', handleMouseDrag);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);
  return null;
};
var ControlPanel = /*#__PURE__*/function (_React$Component) {
  src_inherits(ControlPanel, _React$Component);
  var _super = src_createSuper(ControlPanel);
  function ControlPanel(props) {
    var _this;
    src_classCallCheck(this, ControlPanel);
    _this = _super.call(this, props);
    src_defineProperty(src_assertThisInitialized(_this), "lastSettings", null);
    src_defineProperty(src_assertThisInitialized(_this), "indicateChange", function (label, newVal) {
      var newState = src_objectSpread(src_objectSpread(src_objectSpread({}, _this.state.data), _this.getState()), {}, src_defineProperty({}, label, newVal));
      _this.props.onChange(label, newVal, newState);
      if (!_this.props.state) {
        _this.setState({
          data: newState
        });
      }
    });
    src_defineProperty(src_assertThisInitialized(_this), "handleMouseDown", function (evt) {
      if ((evt.target.className || '').includes('draggable') && evt.button === 0) {
        _this.setState({
          dragging: true,
          mouseDownCoords: {
            x: evt.pageX,
            y: evt.pageY
          },
          mouseDownPos: src_objectSpread({}, _this.state.position)
        });
      }
    });
    src_defineProperty(src_assertThisInitialized(_this), "handleMouseDrag", function (evt) {
      if (_this.state.dragging) {
        var diffX = evt.pageX - _this.state.mouseDownCoords.x;
        var diffY = evt.pageY - _this.state.mouseDownCoords.y;
        var position = (!_this.props.position || typeof _this.props.position === 'string' ? _this.props.position : Object.keys(_this.props.position).join('_')) || '';
        var offset = !position || position.includes('left') ? {
          left: _this.state.mouseDownPos.left + diffX
        } : {
          right: _this.state.mouseDownPos.right - diffX
        };
        var newPosition = src_objectSpread(src_objectSpread({}, _this.state.position), offset);
        if (_this.state.mouseDownPos.top !== undefined) {
          newPosition.top = _this.state.mouseDownPos.top + diffY;
        } else if (_this.state.mouseDownPos.bottom !== undefined) {
          newPosition.bottom = _this.state.mouseDownPos.bottom - diffY;
        }
        if (_this.props.onDrag) {
          _this.props.onDrag(newPosition);
        }
        _this.setState({
          position: maybeSnapToGrid(newPosition, _this.props.dragSnapPx)
        });
      }
    });
    src_defineProperty(src_assertThisInitialized(_this), "handleMouseUp", function () {
      // `setTimeout` here in order to avoid re-rendering the component and potentially discarding
      // new data from child settings that were changed as a result of this.
      setTimeout(function () {
        if (_this.state.dragging) {
          _this.setState({
            dragging: false
          });
        }
      });
    });
    var _position = parsePositionPropToOffsets(props.position);
    _this.state = {
      data: props.initialState || props.state || {},
      position: _position
    };
    _this.derivedSettings = [];
    if (!_this.props.settings) {
      return src_possibleConstructorReturn(_this);
    }
    var _this$computeDerivedS = _this.computeDerivedSettings(_this.props.settings),
      derivedInitialState = _this$computeDerivedS.derivedInitialState;
    _this.state.data = src_objectSpread(src_objectSpread({}, _this.state.data), derivedInitialState);
    return _this;
  }
  src_createClass(ControlPanel, [{
    key: "computeDerivedSettings",
    value: function computeDerivedSettings() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      if (this.lastSettings === settings) {
        return {
          derivedSettings: this.derivedSettings
        };
      }
      this.lastSettings = settings;
      var _settings$reduce = settings.reduce(function (_ref2, _ref3) {
          var derivedInitialState = _ref2.derivedInitialState,
            derivedSettings = _ref2.derivedSettings;
          var type = _ref3.type,
            label = _ref3.label,
            props = src_objectWithoutProperties(_ref3, src_excluded);
          var SettingComponent = settingTypeMapping[type];
          if (!SettingComponent) {
            return {
              derivedInitialState: derivedInitialState,
              derivedSettings: derivedSettings
            };
          }
          return {
            derivedInitialState: 'initial' in props ? src_objectSpread(src_objectSpread({}, derivedInitialState), {}, src_defineProperty({}, label, props.initial)) : derivedInitialState,
            derivedSettings: [].concat(_toConsumableArray(derivedSettings), [{
              SettingComponent: SettingComponent,
              label: label,
              props: props
            }])
          };
        }, {
          derivedInitialState: {},
          derivedSettings: []
        }),
        derivedSettings = _settings$reduce.derivedSettings,
        derivedInitialState = _settings$reduce.derivedInitialState;
      this.derivedSettings = derivedSettings;
      return {
        derivedSettings: derivedSettings,
        derivedInitialState: derivedInitialState
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.props.contextCb) {
        return;
      }
      this.pendingProxySetValues = new Map();
      this.proxyIsSetting = false;

      // `setState` is async, and if we set multiple values while the previous `setState` is
      // happening we can get stale values merged into the state.
      //
      // This prevents that by holding values while `setState` is running until it finishes and then
      // setting them all at once when it does.
      var setStateCb = function setStateCb() {
        if (_this2.pendingProxySetValues.size === 0) {
          _this2.proxyIsSetting = false;
          return;
        }
        var toMerge = Object.fromEntries(_toConsumableArray(_this2.pendingProxySetValues.entries()));
        _this2.pendingProxySetValues.clear();
        _this2.setState({
          data: src_objectSpread(src_objectSpread({}, _this2.state.data), toMerge)
        }, setStateCb);
      };
      var handler = {
        get: function get(_state, prop) {
          return _this2.state.data[prop];
        },
        set: function set(_state, prop, val) {
          if (_this2.proxyIsSetting) {
            _this2.pendingProxySetValues.set(prop, val);
            return true;
          }
          _this2.proxyIsSetting = true;
          _this2.setState({
            data: src_objectSpread(src_objectSpread({}, _this2.state.data), {}, src_defineProperty({}, prop, val))
          }, setStateCb);
          return true;
        }
      };
      var setData = function setData(data) {
        return _this2.setState({
          data: src_objectSpread(src_objectSpread({}, _this2.state.data), data)
        });
      };
      this.props.contextCb(createPolyProxy(this.state.data, handler, setData));
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.props.state ? this.props.state : this.state.data;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        width = _this$props.width,
        suppliedTheme = _this$props.theme,
        _this$props$position = _this$props.position,
        position = _this$props$position === void 0 ? '' : _this$props$position,
        title = _this$props.title,
        children = _this$props.children,
        style = _this$props.style,
        settings = _this$props.settings,
        className = _this$props.className,
        draggable = _this$props.draggable;
      var theme = is_string_default()(suppliedTheme) ? themes[suppliedTheme] || themes['dark'] : suppliedTheme;
      var state = this.getState();
      var combinedStyle = src_objectSpread(src_objectSpread({
        display: 'inline-block',
        background: theme.background1,
        width: width,
        padding: 14,
        paddingBottom: 8,
        opacity: 0.95,
        position: VALID_POSITIONS.includes(position) || typeof position !== 'string' ? 'absolute' : undefined
      }, this.state.position || {}), {}, {
        cursor: draggable ? 'move' : undefined
      }, style);
      var _this$computeDerivedS2 = this.computeDerivedSettings(settings),
        derivedSettings = _this$computeDerivedS2.derivedSettings;
      return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement("div", {
        className: "control-panel draggable".concat(className ? ' ' + className : ''),
        onMouseDown: draggable ? this.handleMouseDown : undefined,
        style: combinedStyle
      }, draggable ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(DragHelper, {
        handleMouseDrag: this.handleMouseDrag,
        handleMouseUp: this.handleMouseUp
      }) : null, /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(context.Provider, {
        value: {
          state: state,
          theme: theme,
          indicateChange: this.indicateChange
        }
      }, title ? /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(components_title, {
        title: title
      }) : null, children, derivedSettings.map(function (_ref4) {
        var SettingComponent = _ref4.SettingComponent,
          label = _ref4.label,
          props = _ref4.props;
        return /*#__PURE__*/external_root_React_commonjs_react_commonjs2_react_amd_react_default().createElement(SettingComponent, src_extends({
          key: label,
          label: label
        }, props, {
          value: state[label]
        }));
      })));
    }
  }]);
  return ControlPanel;
}((external_root_React_commonjs_react_commonjs2_react_amd_react_default()).Component);
ControlPanel.propTypes = {
  initialState: (prop_types_default()).object,
  onChange: (prop_types_default()).func,
  theme: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).object]),
  title: (prop_types_default()).string,
  width: (prop_types_default()).number,
  position: prop_types_default().oneOfType([prop_types_default().oneOf(VALID_POSITIONS), (prop_types_default()).string, (prop_types_default()).object]),
  style: (prop_types_default()).object,
  settings: prop_types_default().arrayOf((prop_types_default()).object),
  state: (prop_types_default()).object,
  contextCb: (prop_types_default()).func,
  draggable: (prop_types_default()).bool,
  onDrag: (prop_types_default()).func,
  className: (prop_types_default()).string
};
ControlPanel.defaultProps = {
  width: 300,
  theme: 'dark',
  onChange: function onChange() {},
  style: {},
  className: null
};
/* harmony default export */ const src = (ControlPanel);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map